import { EWsStatus } from 'src/app/shared/enums/websocket-status.enum';
import * as get from 'lodash.get';

function receivedHandler(send: (p: any) => void, res: any) {
  const action: EWsStatus = get(res, 'message.action', '');

  if (action === EWsStatus.NEW_CONNECTION) {
    send({ action: EWsStatus.INITIALIZE });
  }
}

export default receivedHandler;
